import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';
import { GitBranch } from '@phosphor-icons/react';

const ConditionNode = memo(({ data, selected }) => {
  return (
    <div
      data-testid="flow-node-condition"
      className={`
        group relative min-w-[180px] max-w-[220px] rounded-[10px] overflow-hidden
        bg-[var(--surface-2)] border-l-[3px] border transition-all duration-150
        ${selected
          ? 'border-l-amber-400 border-[var(--border-strong)]'
          : 'border-l-amber-500 border-[var(--border-default)] hover:border-[var(--border-strong)]'}
      `}
    >
      <Handle
        type="target"
        position={Position.Left}
        className="!w-[10px] !h-[10px] !border-2 !left-[-6px] transition-colors
          !bg-amber-400 !border-amber-300/50 hover:!bg-amber-300"
      />

      {/* Header */}
      <div className="flex items-center gap-2.5 px-3 pt-3 pb-2">
        <div className="flex-shrink-0 w-[34px] h-[34px] rounded-lg bg-amber-500/10 border border-amber-500/20 flex items-center justify-center">
          <GitBranch size={20} weight="duotone" className="text-amber-400" />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[13px] font-semibold text-white truncate leading-tight">{data.label || 'Condition'}</p>
          <span className="text-[10px] text-amber-400/60 font-medium uppercase tracking-wider">Logic</span>
        </div>
      </div>

      {/* Body - condition info */}
      <div className="px-3 pb-2.5 pt-0.5 border-t border-white/[0.04]">
        <p className="text-[10px] text-slate-500 truncate">
          {data.condition || 'If / Then'}
        </p>
      </div>

      {/* True handle */}
      <Handle
        type="source"
        position={Position.Right}
        id="true"
        style={{ top: '35%' }}
        className="!w-[10px] !h-[10px] !border-2 !right-[-6px] transition-colors
          !bg-emerald-400 !border-emerald-300/50 hover:!bg-emerald-300"
      />
      <span className="absolute right-3 text-[8px] font-bold text-emerald-500/50 uppercase" style={{ top: 'calc(35% - 10px)' }}>yes</span>

      {/* False handle */}
      <Handle
        type="source"
        position={Position.Right}
        id="false"
        style={{ top: '70%' }}
        className="!w-[10px] !h-[10px] !border-2 !right-[-6px] transition-colors
          !bg-red-400 !border-red-300/50 hover:!bg-red-300"
      />
      <span className="absolute right-3 text-[8px] font-bold text-red-500/50 uppercase" style={{ top: 'calc(70% - 10px)' }}>no</span>
    </div>
  );
});

ConditionNode.displayName = 'ConditionNode';
export default ConditionNode;
